const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:9000/api/',

  BACKEND_BASE_URL:
    process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:9000/api/',
};

export default config;